(function (app) {
    'use strict';

    app.factory('languageServices', languageServices);

    /*@ngInject*/
    function languageServices($translate, $state, $stateParams, dataservice, logger){
        var languages = null;
        var options = [{'id': 7, 'name': 'languages'}];
        var passthrough = {validOnly:true};
        return  {
            updateLanguage:updateLanguage,
            getLanguagesPromise:getLanguagesPromise
        };

        function updateLanguage(key){
            if(key && $translate){
                $translate.use(key);
//                obtSession.setLanguage(key); // set the selected language for the session
                if(!$stateParams){$stateParams = {}}
                $stateParams.language = key;
                var stateToRedirect = $state.current.data && $state.current.data.home ? $state.current.data.home : $state.current.name;
                console.log(stateToRedirect);
                $state.transitionTo(stateToRedirect, $stateParams, { reload: true });
            }
        }

        function getLanguagesPromise(args, passThroughArgs){
            var passThroughExtended = angular.extend({}, passthrough, passThroughArgs); //keep order

            return dataservice.form.getOptions(options, passThroughExtended , args)
                .then(function(result){
                    if(result){//} && result.error === 0){
                        return result.languages || []; //dataservice.form.getOptionsFrom(result.updateComboBox, 'languages');
                    }else{
                        logger.error(result.body ? result.body : 'Get language failed', result);
                        return [];
                    }
                });
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/language/language.services.js
 ** module id = 212
 ** module chunks = 0
 **/